import { render, staticRenderFns } from "./WsMainExpertManagement.vue?vue&type=template&id=a1733f9c&scoped=true"
import script from "./WsMainExpertManagement.vue?vue&type=script&lang=js"
export * from "./WsMainExpertManagement.vue?vue&type=script&lang=js"
import style0 from "./WsMainExpertManagement.vue?vue&type=style&index=0&id=a1733f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1733f9c",
  null
  
)

export default component.exports